// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fRGY","label":"styles_label__1JZ6b"};